<template>
    <modal-base :pacifier="false">
        <template #title>
            Live Connection Was Unsuccessful
        </template>

        <template #subtitle>Schedule an appointment with your Unbundled Lawyer below:</template>
    </modal-base>
</template>

<script>
    export default {
        mounted() {
            this.$store.commit('card', 'calendar');
        }
    }
</script>
